import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// API for creating customer entry
export const postCustomerEntry = (payload,headers) => {
  return Axios.post(`addCustomer`, payload, {
    headers
  });
};

// API for updating customer details
export const putCustomerEntry = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`updateCustomer`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// API for getting list of all customer
export const getCustomerEntry = (pageNo,headers) => {
  return Axios.get(`getListOfCustomer/${pageNo}`, {
    headers
  });
};

// API for getting list of all customer by from and to date
export const getCustomerEntryByDate = (pageNo,fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `getCustomerDetailsBetWeenTwoDates/${pageNo}?fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
// API for date wise pdf download
export const getCustomerPdfDownload = (fromDate,toDate) => {
  let fileType = ["Pdf"]
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `getCustomerReportInPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  )
  .then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `customerreport.pdf`);
  });
};

export const getCustomerEntryExcelDownload = (fromDate, toDate) => {
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(`getCustomerReportInPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}`, {
    headers: {Authorization: `Bearer ${token}` },
    responseType: "arraybuffer",
  })
  .then((result) => {
    let blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
    fileSaver.saveAs(blob, "customerListBetweenTwoDateExcel.xlsx");
  });
};

// API for getting list of all customer for Drop Down
export const getCustomerEntryforDropDown = (headers) => {
  return Axios.get(`/User/getCustomerNameDropDown`, {
    headers
  });
};

// API for getting details of customer by id
export const getCustomerEntryById = (headers,pk_customer_id) => {
  return Axios.get(`/User/${pk_customer_id}`, {
    headers
  });
};


export const getCustomerLExcel = () => {

  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(`getCustomerListExcel?fileType=${fileType}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "arraybuffer",
  })
};
